import { DataStore } from 'mobx/dataStore';

export class RootStore {
  public dataStore: DataStore.Store;

  constructor() {
    this.dataStore = new DataStore.Store({ rootStore: this });
  }
}

const rootStore = new RootStore();
export default rootStore;
